import { z } from "zod";

export const CourseSearchResponseSchema = z.object({
  search_key: z.string(),
  count: z.number(),
  courses: z.array(z.string()),
});

export const PreEvaluationReportResponseSchema = z.union([
  z.object({
    status: z.literal("success"),
    blob_url: z.string(),
  }),
  z.object({
    status: z.literal("completed"),
    blob_url: z.string().nullable().optional(),
  }),
  z.object({
    status: z.literal("error"),
    error_code: z.string().optional(),
    message: z.string().optional(),
  }),
]);

export type CourseSearchResponse = z.infer<typeof CourseSearchResponseSchema>;
export type PreEvaluationReportResponse = z.infer<
  typeof PreEvaluationReportResponseSchema
>;
